module.exports = __webpack_public_path__ + "static/img/1-1Z5241K351456.a9dc262.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1-1Z5241K351456.jpg
// module id = O0Ec
// module chunks = 0